import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
  OnDestroy,
  ElementRef,
} from "@angular/core";
import { FnTimepickerService } from "./../services/timepicker.service";
import { isNonEmptyString } from "../../../util/check";
import { FnTimeDuration } from "../../../constant/fn-duration-time-picker.enum";

@Component({
  selector: "fn-duration-time-picker",
  templateUrl: "fn-duration-time-picker.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class FnDurationTimePickerComponent implements OnInit, OnDestroy {
  @Input() value: string | number;
  @Input() placeholder: string;
  @Input() name: string;
  @Input() parentForm: any;
  @Input() appendTo: string;
  @Input() isDisabled = false;
  @Output() timeChanged: EventEmitter<FnTimeDuration> = new EventEmitter();
  defaultArraySlots: Array<string> = [":00", ":15", ":30", ":45"];
  arrayItemSlots: Array<string> = [];
  regexMap: any;
  showDropDown = false;
  errorMessageList: Array<string> = [
    "Invalid Max Hours Per Week format.",
    "Max Hours Per Week cannot be more than 168 hours.",
    "Max Hours Per Week cannot be less than 15 mins.",
  ];
  acceptedInputKeysList = ["1","2","3","4","5","6","7","8","9","0",":","ArrowDown","ArrowUp","ArrowLeft","ArrowRight",
    "Backspace","Delete","Enter"];
  activeItem: number;
  defaultValue = "";
  private nativeElem: HTMLElement;

  constructor(
    private timePickerSvcs: FnTimepickerService,
    private elemeRef: ElementRef
  ) {}

  ngOnDestroy() {}

  ngOnInit() {
    this.nativeElem = this.appendTo
      ? document.querySelector(this.appendTo)
      : this.elemeRef.nativeElement;
    const hours = Math.floor(Number(this.value) / 60) + "";
    const mnts = Math.floor(Number(this.value) % 60) + "";
    this.defaultValue = this.value =
      this.value && this.value !== 0
        ? (hours.length === 1 ? "0" + hours : hours) +
          ":" +
          (mnts.length === 1 ? mnts + "0" : mnts)
        : "";
    this.value = this.value.toString();
    this.regexMap = this.timePickerSvcs.regexMap;
  }

  durationTimeFn(evt: any) {
    const arraySlotCopy = [];
    this.defaultValue = JSON.parse(JSON.stringify(this.value));
    if (
      isNonEmptyString(this.value.toString()) &&
      (this.regexMap.digitRegex.test(this.value.toString()) ||
        this.regexMap.durationValueRegex.test(this.value.toString()))
    ) {
      this.activeItem = 0;
      const splitValue = this.value.toString().split(":");
      for (const dArrSlot of this.defaultArraySlots) {
        arraySlotCopy.push(splitValue[0] + dArrSlot);
      }
      this.arrayItemSlots = arraySlotCopy;
      this.showDropDown = true;
    } else {
      this.arrayItemSlots = [];
      this.showDropDown = false;
      this.timeChanged.emit(new FnTimeDuration(0, this.errorMessageList[2]));
    }
  }

  keydownEvent(event: KeyboardEvent) {
    if (this.arrayItemSlots.length > 0) {
      switch (event.key) {
        case this.timePickerSvcs.KEY_CODES.ENTER:
          this.selectTimeOnEnter();
          break;
        case this.timePickerSvcs.KEY_CODES.ARROW_UP:
          this.setActiveTimeOnArrowKey(true);
          break;
        case this.timePickerSvcs.KEY_CODES.ARROW_DOWN:
          this.setActiveTimeOnArrowKey(false);
          break;
        default:
          break;
      }
    }
    event.stopPropagation();
  }

  setActiveTimeOnArrowKey(isKeyUp:boolean) {
    if (isKeyUp) {
      if (this.activeItem === 0) {
        this.activeItem = -1;
      } else {
        if (this.activeItem === -1) {
          this.activeItem = this.arrayItemSlots.length - 1;
        } else {
          this.activeItem -= 1;
        }
      }
    } else {
      if (this.activeItem === this.arrayItemSlots.length) {
        this.activeItem = -1;
      } else {
        this.activeItem += 1;
      }
      if (this.activeItem === -1) {
        this.activeItem = 0;
      }
    }
    this.value =
      this.activeItem > -1 && this.activeItem < 4
        ? this.getActiveTime()
        : this.defaultValue;
  }

  private getMinsFromString() {
    const splitText = this.value.toString().split(":");
    const isSelectedVal =
      this.defaultArraySlots.indexOf(":" + splitText[1]) !== -1;
    const mins =
      Number(splitText[0]) * 60 + (splitText[1] ? Number(splitText[1]) : 0);
    if (
      this.timePickerSvcs.regexMap.validValueRegex.test(
        this.value.toString()
      ) &&
      isSelectedVal &&
      mins <= 10080
    ) {
      this.timeChanged.emit(
        new FnTimeDuration(mins, mins === 0 ? this.errorMessageList[2] : "")
      );
    } else {
      const errorMsg =
        !this.timePickerSvcs.regexMap.validValueRegex.test(
          this.value.toString()
        ) && mins <= 10080
          ? this.errorMessageList[0]
          : !isSelectedVal && mins <= 10080
          ? this.errorMessageList[0]
          : this.errorMessageList[1];
      this.timeChanged.emit(new FnTimeDuration(0, errorMsg));
    }
  }

  retrictAlphaCharKeys(event: KeyboardEvent) {
    const isAccepted = this.acceptedInputKeysList.indexOf(event.key) !== -1;
    if (isAccepted) {
      return true;
    }
    event.preventDefault();
    event.stopPropagation();
    return false;
  }

  toggleSelect(toggelValue: boolean) {
    this.showDropDown = !toggelValue;
  }

  onItemClick() {
    this.value = this.getActiveTime();
    this.closeDropDown();
  }

  selectTimeOnEnter() {
    this.value = this.getActiveTime();
    this.closeDropDown();
  }

  closeDropDown() {
    this.getMinsFromString();
    this.arrayItemSlots = [];
    this.showDropDown = false;
  }

  private getActiveTime() {
    return this.arrayItemSlots[this.activeItem];
  }

  public resetValue() {
    this.value = this.defaultValue = "";
    this.arrayItemSlots = [];
    this.showDropDown = false;
    this.activeItem = -1;
    this.timeChanged.emit(new FnTimeDuration(0, ""));
  }
}
